import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  isAuthenticated: false,
  currentUserEmail: '',
  userRole: 'master',
  isCheckingAuth: true,
  
  setAuth: (isAuthenticated, email, role) => set({ 
    isAuthenticated, 
    currentUserEmail: email || '', 
    userRole: role || 'master',
    isCheckingAuth: false 
  }),
  
  setIsCheckingAuth: (isChecking) => set({ isCheckingAuth: isChecking }),
  
  logout: () => set({
    isAuthenticated: false,
    currentUserEmail: '',
    userRole: 'master'
  })
}));
